const SELECTORS = Object.freeze({
  FORM: '.js-rewardFilters',
  FORM_WRAPPER: '.js-rewardsFilterContainer',
  DROPDOWN: '.js-filterDropdown',
  DROPDOWN_MENU: '.js-filterDropdown ul',
  DROPDOWN_TRIGGER: '.js-filterDropdownTrigger',
  CALCULATOR_FIELDS: '.js-calculator-fields',
  CALCULATOR_INPUT: '.js-calculator-fields:not([name="type"])',
  CALCULATOR_INPUT_DISPLAY: '.js-calculator-input',
  CHECKBOX: 'input[type="checkbox"]',
  CHECKBOX_CHECKED: 'input[type="checkbox"]:checked',
  ALL_CHECKBOX: 'input[id^=all]',
  SLIDER: '.js-nouislider',
  SLIDER_LABEL_ID: 'bonusPointsSlider__label',
  SLIDER_INPUT_ID: 'bonusPointsSlider__value',
  SLIDER_FIELD: 'cc_bonus_points_signup',
  TOGGLE: '.js-toggleFilters',
  EDIT_FORM: '.js-editFilters',
  APPLY: '.js-applyFilters',
  RESET: '.js-resetRewardFilters',
  RESULT_COUNT: '.js-filtersResultCount',
  CANCEL: '.js-cancelFilters',
  COMPARISON_TABLE: '.js-comparison-table',
  COMPARISON_CALCULATOR: '.js-comparison-calculator',
  REVERSED_COMPARISON_CALCULATOR: 'comparison-calculator--reversedDesign',
  HIDDEN_FILTER_FORM: 'comparison-calculator--filterHidden',
  TRACKING_DATA_ATTR_ACTION: 'data-track-filter-action',
  TRACKING_DATA_ATTR_LABEL: 'data-track-filter-label',
});

const IS_VISIBLE = 'is-visible';
const IS_HIDDEN = 'is-hidden';
const IS_SHOWN = 'is-shown';
const FILTER_OPEN = 'filter-open';
const ALL_CHECKED = '===all';

const SLIDER_DISPLAY_MAPPER = [
  'Not filtering by bonus offer',
  '<strong>Only</strong> cards with bonus offers',
  '<strong>25,000 points</strong> or more',
  '<strong>50,000 points</strong> or more',
  '<strong>75,000 points</strong> or more',
  '<strong>100,000 points</strong> or more',
];

const SLIDER_VALUE_MAPPER = [
  ALL_CHECKED,
  '>=1',
  '>=25000',
  '>=50000',
  '>=75000',
  '>=100000',
];

export {
  SELECTORS,
  IS_VISIBLE,
  IS_HIDDEN,
  IS_SHOWN,
  FILTER_OPEN,
  ALL_CHECKED,
  SLIDER_DISPLAY_MAPPER,
  SLIDER_VALUE_MAPPER,
};
